export function formatClipConfiguration(action: any) {
  const deleteNullValues = (overlays: any) => {
    overlays.forEach((overlay: any) => {
      if (overlay.colorkey && overlay.type !== 'video') {
        // eslint-disable-next-line no-param-reassign
        delete overlay.colorkey;
      }

      Object.keys(overlay).forEach(key => {
        if (overlay[key] === null) {
          // eslint-disable-next-line no-param-reassign
          delete overlay[key];
        }
      });
    });
  };

  if (action.formData.clipConfiguration) {
    if (action.formData.clipConfiguration.overlays && action.formData.clipConfiguration.overlays.length > 0) {
      deleteNullValues(action.formData.clipConfiguration.overlays);
    }

    if (
      action.formData.clipConfiguration.creditSequence.overlays &&
      action.formData.clipConfiguration.creditSequence.overlays.length > 0
    ) {
      deleteNullValues(action.formData.clipConfiguration.creditSequence.overlays);
    }
  }
}
